import { render, staticRenderFns } from "./personCast.vue?vue&type=template&id=5212d1d4&"
import script from "./personCast.vue?vue&type=script&lang=js&"
export * from "./personCast.vue?vue&type=script&lang=js&"
import style0 from "./personCast.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5212d1d4')) {
      api.createRecord('5212d1d4', component.options)
    } else {
      api.reload('5212d1d4', component.options)
    }
    module.hot.accept("./personCast.vue?vue&type=template&id=5212d1d4&", function () {
      api.rerender('5212d1d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/personCast.vue"
export default component.exports